
<template>
  <div>
    <dialog-create-project></dialog-create-project>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateProject from '../../components/projects/control/DialogCreateProject.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'NewProjectPage',
  //mixins: [ validations ],
  components: {
    DialogCreateProject
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>